import type { ComponentPropsWithoutRef, ReactElement, ReactNode } from 'react';

import styles from './Card.module.css';

export interface CardProps extends ComponentPropsWithoutRef<'section'> {
    /** Rendered as the card heading. Use `headingLevel` to keep the outline sequential. */
    title?: string | undefined;
    headingLevel?: 2 | 3 | undefined;
    /** Content aligned to the end of the header row, e.g. a status badge or action. */
    headerEnd?: ReactNode;
    tone?: 'default' | 'muted' | undefined;
}

export function Card({
    title,
    headingLevel = 2,
    headerEnd,
    tone = 'default',
    className,
    children,
    ...rest
}: CardProps): ReactElement {
    const Heading = headingLevel === 2 ? 'h2' : 'h3';
    const classes = [styles.card, tone === 'muted' ? styles.muted : undefined, className]
        .filter(Boolean)
        .join(' ');
    return (
        <section className={classes} {...rest}>
            {title !== undefined || headerEnd !== undefined ? (
                <header className={styles.header}>
                    {title !== undefined ? (
                        <Heading className={styles.title}>{title}</Heading>
                    ) : (
                        <span />
                    )}
                    {headerEnd}
                </header>
            ) : null}
            <div className={styles.body}>{children}</div>
        </section>
    );
}
